/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 *
 * Manages fields, a replacement for JSON Schema.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "namespace",
    title: "Namespace",
    description: "A namespace string, usually for a universe element, plugin, or other app related component. Dot-separated segments where each segment starts with a letter, underscore, or dollar sign, followed by letters, digits, underscores, or dollar signs.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validSimple: {
            must: true,
            run: function () {
                return validate({ title: "Namespace" }, "mymodule");
            }
        },
        validDotted: {
            must: true,
            run: function () {
                return validate({ title: "Namespace" }, "ua.navbar.item");
            }
        },
        validWithDollar: {
            must: true,
            run: function () {
                return validate({ title: "Namespace" }, "$app.module1");
            }
        },
        validUnderscore: {
            must: true,
            run: function () {
                return validate({ title: "Namespace" }, "_internal.core");
            }
        },
        invalidSpaces: {
            throw: "fields.namespace.patternMismatch",
            run: function () {
                return validate({ title: "Namespace" }, "my namespace");
            }
        },
        invalidStartsWithNumber: {
            throw: "fields.namespace.patternMismatch",
            run: function () {
                return validate({ title: "Namespace" }, "1bad.namespace");
            }
        },
        invalidDoubleDot: {
            throw: "fields.namespace.patternMismatch",
            run: function () {
                return validate({ title: "Namespace" }, "bad..namespace");
            }
        },
        invalidType: {
            throw: "fields.namespace.invalid",
            run: function () {
                return validate({ title: "Namespace" }, 42);
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Namespace",
            description: "The value must be a string.",
            template: "Expected string but received ${typeof}"
        },
        patternMismatch: {
            title: "Invalid Namespace Format",
            description: "A namespace must be dot-separated segments, each starting with a letter, underscore, or dollar sign.",
            template: "Invalid namespace: '${value}'. Each segment must start with a letter, underscore, or $, followed by letters, digits, underscores, or $."
        }
    }
});

var namespacePattern = /^[a-z_$][a-z0-9_$]*(\.[a-z_$][a-z0-9_$]*)*$/;

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ typeof: typeof value });
    }

    if (!namespacePattern.test(value)) {
        _.errors.patternMismatch.throw({ value: value });
    }
}
module.exports.validate = validate;
